import { render, staticRenderFns } from "./MovementsPageSecondaryMarket.vue?vue&type=template&id=012032ce&scoped=true&"
import script from "./MovementsPageSecondaryMarket.vue?vue&type=script&lang=js&"
export * from "./MovementsPageSecondaryMarket.vue?vue&type=script&lang=js&"
import style0 from "./MovementsPageSecondaryMarket.vue?vue&type=style&index=0&id=012032ce&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012032ce",
  null
  
)

export default component.exports